/**
 * Agent-written prose is markdown-flavoured, and this app renders it into plain
 * text nodes. Parsing it into HTML would mean turning agent output -- which has
 * read issue bodies, PR descriptions and diffs -- into markup, so the markers
 * are removed as text instead and nothing is ever interpreted.
 *
 * Worst case someone loses a pair of asterisks. That is a better worst case
 * than the alternative.
 */
export function stripMarkers(text: string): string {
  return text
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/^\s*[-*]\s+/gm, '• ')
}

/** Same, but tolerant of the null a jsonb read can hand back. */
export function stripMarkersOrNull(text: string | null): string | null {
  return text === null ? null : stripMarkers(text)
}

/**
 * Label a key without a lookup table: ran_at -> "Ran at", project_ref ->
 * "Project ref".
 *
 * Shared by the mappers that harvest an open jsonb object generically. A
 * lookup table would mean a key nobody has written yet arrives with no label,
 * which is the same failure as dropping it.
 */
export function humanise(key: string): string {
  const words = key.replace(/[_-]+/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').trim()
  return words.charAt(0).toUpperCase() + words.slice(1)
}

/** One line of it: whitespace collapsed, cut at `max` with an ellipsis. */
export function short(text: string, max = 140): string {
  const flat = text.replace(/\s+/g, ' ').trim()
  return flat.length > max ? `${flat.slice(0, max - 1)}…` : flat
}
